import React from 'react';
import { Grid, Row, Col, Nav, Navbar, NavItem } from 'react-bootstrap';

import styles from './Footer.module.scss';

function Footer() {
  return (
    <footer className={styles.footer}>
      <Grid className={styles.container}>
        <Row>
          <Col md={6}>
            Copyright {(new Date()).getFullYear()} time:matters &nbsp;&nbsp;
            <a
              href="http://www.time-matters.com/en/imprint/"
              target="_blank"
              rel="noopener noreferrer"
            >
              IMPRINT
            </a>&nbsp;
            <a
              href="https://www.time-matters.com/data-protection-notice/"
              target="_blank"
              rel="noopener noreferrer"
            >Privacy Policy
            </a>&nbsp;
            <a href="/PrivacyPolicy_english_APP.pdf" target="_blank" rel="noopener noreferrer">
              Airmates App Privacy Policy
            </a>
          </Col>
          <Col md={6}>
            <Navbar role="navigation" className={styles.navigation}>
              <Navbar.Header>
                <Navbar.Toggle />
              </Navbar.Header>
              <Navbar.Collapse className={styles.collapse}>
                <Nav>
                  <NavItem href="https://www.facebook.com/time.matters.page">
                    <i className="fa fa-facebook fa-lg" />
                  </NavItem>
                  <NavItem href="http://twitter.com/time_matters">
                    <i className="fa fa-twitter fa-lg" />
                  </NavItem>
                  <NavItem href="https://plus.google.com/+timemattersGmbHNeuIsenburg/">
                    <i className="fa fa-google-plus fa-lg" />
                  </NavItem>
                  <NavItem
                    href="https://www.xing.com/companies/time%253Amattersgmbh-acompanyoflufthansacargo/employees"
                  >
                    <i className="fa fa-xing fa-lg" />
                  </NavItem>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </Col>
        </Row>
      </Grid>
    </footer>
  );
}

export default Footer;
